export default __webpack_public_path__ + "static/media/ticket.09a7d84c.svg";